<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <van-nav-bar
      left-arrow
      title="工单详情"
      left-text="返回"
      @click-left="$emit('update:show', false)">
    </van-nav-bar>
    <van-tabs v-model="active" type="card" style="flex-grow: 1">
      <van-tab title="车辆信息">
        <wx-work-detail-panel :work="work"></wx-work-detail-panel>
      </van-tab>
      <van-tab v-if="!pattern" title="操作记录">
        <wx-opera-record-panel :records="operaRecords"></wx-opera-record-panel>
      </van-tab>
      <van-tab title="维修信息">
        <wx-loss-determ-panel :work="work"></wx-loss-determ-panel>
      </van-tab>
    </van-tabs>
    <div v-show="pattern" style="text-align: center; margin-bottom: 40px">
      <van-button size="normal" style="width: 100px" type="info" @click="next">下一步</van-button>
    </div>
    <van-popup v-model="showDispatch" position="center" style="width: 100%; height: 100%">
      <wx-dispatch-page :work="work" :pattern="pattern" :show.sync="showDispatch"
                        @closeParent="$emit('update:show', false)"></wx-dispatch-page>
    </van-popup>
  </div>
</template>

<script>
  import { Button, NavBar, Popup, Tab, Tabs } from 'vant'
  import { afterWorkProcedures, getWorkDetail, workOperaRecord } from '@/utils/request'
  import WxOperaRecordPanel from '@/views/wx/work-detail/WxOperaRecordPanel'
  import WxLossDetermPanel from '@/views/wx/work-detail/WxLossDetermPanel'
  import WxWorkDetailPanel from '@/views/wx/work-detail/WxWorkDetailPanel'
  import WxDispatchPage from '@/views/wx/work-detail/WxDispatchPage'

  const lodash = require('lodash')

  export default {
    name: 'WxWorkDetail',
    components: {
      WxDispatchPage,
      WxWorkDetailPanel,
      WxLossDetermPanel,
      WxOperaRecordPanel,
      [NavBar.name]: NavBar,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Button.name]: Button,
      [Popup.name]: Popup
    },
    props: {
      work: Object,
      show: Boolean,
      pattern: String
    },
    data () {
      return {
        active: 0,
        operaRecords: [],
        showDispatch: false
      }
    },
    methods: {
      debounceUpdateWork: lodash.debounce(function () {
        workOperaRecord(this.work.id).then(response => {
          this.operaRecords = response.data
        })
        getWorkDetail(this.work.id).then(work => {
          this.$set(this.work, 'lossDeterm', work.lossDeterm)
        })
        if (this.pattern) {
          afterWorkProcedures(this.work.id).then(response => {
            this.$set(this.work, 'dispatchList', response.data)
          })
        }
      }, 1000),
      next () {
        const count = this.pattern ? 2 : 3
        if (this.active < count - 1) {
          ++this.active
        } else {
          this.showDispatch = true
        }
      }
    },
    watch: {
      show: {
        handler (value) {
          this.active = 0
          if (value) {
            this.debounceUpdateWork()
          } else {
            this.showDispatch = false
            this.operaRecords = []
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .van-tabs__nav--card {
      margin: 0;
      border-radius: 0;
      height: 38px;
      border-width: 0;
    }

    .van-tabs--card > .van-tabs__wrap {
      height: 38px;
    }

    .van-tabs__nav--card .van-tab.van-tab--active {
      background-color: #1890ff;
      border-width: 0;
      color: white;
    }

    .van-tabs__nav--card .van-tab {
      background-color: lightgrey;
      border-width: 0;
      color: black;
    }
  }
</style>
